/*
 * Disclaimer appare non appena l'utente preme su KARNAKMED
 * Al click di prosegui, salvare la selezione dell'utente in una Session Storege
 * .checked == true o false
 */
const saveMedicalSessionStorage = () => {
    const dataSessionStorage = sessionStorage.getItem("typeOperator");
    const medicalDisclaimer = document.querySelector(".medical-disclaimer");
    const medic = document.getElementById("medic");
    const notMedic = document.getElementById("not-medic");
    if (medicalDisclaimer) {
        if (!dataSessionStorage) {
            document.body.classList.add("disclaimer-open");
            medicalDisclaimer.classList.add("active");
            const subscribeMedicalDisclaimer = document.getElementById("confirm-subscribe");
            subscribeMedicalDisclaimer.addEventListener("click", () => {
                setTimeout(() => {
                    if (medic.checked == true) {
                        sessionStorage.setItem("typeOperator", medic.value);
                    }
                    else if (notMedic.checked == true) {
                        sessionStorage.setItem("typeOperator", notMedic.value);
                    }
                }, 0);
            });
        }
        else if (medicalDisclaimer && dataSessionStorage == medic.value) {
            document.body.classList.remove("disclaimer-open");
            medicalDisclaimer.classList.remove("active");
        }
        else if (medicalDisclaimer && dataSessionStorage == notMedic.value) {
            sessionStorage.removeItem("typeOperator");
            document.body.classList.add("disclaimer-open");
            medicalDisclaimer.classList.add("active");
        }
    }
};
